
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "WildBookEntryAnimal",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "",
      form: "WildbuchEintragJagd",
      page: "WildbuchEintragTierartJagd",
      remoteId: "",
      

      

    });
    return {
      request
    };
  }
};
